import { Divider } from '@material-ui/core';
import useGetVehicle from '../hooks/useGetVehicle';
import createVehicleDescription from '../utils/createVehicleDescription';
import formatNumber from '../utils/formatNumber';
import CallButton from './CallButton';
import SendMessageButton from './SendMessageButton';
import SeparateButton from './SeparateButton';
import ShareVehicleButton from './ShareVehicleButton';
import VehicleSeller from './VehicleSeller';
import WhatsappButton from './WhatsappButton';
import useConfig from '../hooks/useConfig';

const VehicleSummary = () => {
  const { vehicle } = useGetVehicle();
  const { descriptionCertificationBadge, listedCertificationBadge } = useConfig();
  const certificationBadge = descriptionCertificationBadge || listedCertificationBadge;

  return (
    <>
      <h1 className="description text-2xl">{createVehicleDescription(vehicle)}</h1>
      <p className="text-sm text-gray-500 mb-2">
        {`${vehicle.year} | ${formatNumber(vehicle.kms)} km | ${vehicle.location}`}
      </p>
      <p className="pricing text-4xl text-pricing">
        {`$ ${formatNumber(vehicle.price)}`}
        <span className="text-lg">{vehicle.seller.currency}</span>
      </p>

      <Divider className="my-4" />

      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-1">
        <SendMessageButton className="w-full" />
        <WhatsappButton className="w-full" />
        <SeparateButton className="w-full" />
        <CallButton className="w-full" />
        <ShareVehicleButton className="w-full" />
      </div>

      <Divider className="my-4" />

      <div className="flex gap-8 flex-wrap">
        <VehicleSeller />

        {certificationBadge && vehicle.certified && (
          <img alt="Certified" src={certificationBadge} className="h-20 object-contain" />
        )}
      </div>
    </>
  );
};

export default VehicleSummary;
